var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnifyLogoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 26,
    viewBox: "0 0 104 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4669 23.0236C33.9616 23.0236 32.0121 22.4147 30.6182 21.1969C29.2432 19.9791 28.5557 18.219 28.5557 15.9166V4.35693H31.6354V15.8024C31.6354 17.3437 32.0498 18.4949 32.8786 19.256C33.7262 20.0171 34.9223 20.3977 36.4669 20.3977C37.9926 20.3977 39.1699 20.0171 39.9986 19.256C40.8463 18.4949 41.2701 17.3437 41.2701 15.8024V4.35693H44.3216V15.9166C44.3216 18.219 43.634 19.9791 42.259 21.1969C40.8839 22.4147 38.9532 23.0236 36.4669 23.0236Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.018 22.7382V4.35693H50.7304L60.2239 17.886V4.35693H63.2753V22.7382H60.5629L51.0977 9.23767V22.7382H48.018Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1459 22.7382V4.35693H70.2256V22.7382H67.1459Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0782 22.7382V4.35693H86.4535V6.78303H77.1579V12.3488H85.4081V14.7463H77.1579V22.7382H74.0782Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4219 22.7382V15.9166L87.8952 4.35693H91.0879L95.9476 13.2907L100.807 4.35693H104L97.4734 15.9166V22.7382H94.4219Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.036C0 17.8755 0.705845 23.4488 5.23985 25.1408C8.72325 23.9805 9.8893 21.1327 10.0369 19.8538V13.2397V11.1095C8.61993 6.29303 2.75523 5.0889 0 5.0889V12.6147V13.036Z",
    fill: "#D50E0B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C16.6816 0.149624 13.7772 1.20682 11.9583 2.85848C10.0389 4.60135 10.0369 7.46734 10.0369 10.06V11.1095V13.2397V19.8538C9.8893 21.1327 8.72325 23.9805 5.23985 25.1408C7.93853 26.1479 11.1674 26.2664 13.9399 25.5134C19.2634 24.0675 20 17.5538 20 12.0375V6.164V0Z",
    fill: "url(#paint0_linear_133_21330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_21330",
    x1: 8.28121,
    y1: 26.0242,
    x2: 23.3851,
    y2: -5.95899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#550604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD341B"
  })))));
}

export default __webpack_public_path__ + "media/aeb921b2.svg";
export { SvgUnifyLogoText as ReactComponent };